(() => {
  const selectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  document.querySelectorAll('[data-unfazed-section]').forEach((section) => {
    const form = section.querySelector('[data-unfazed-form]');
    const status = section.querySelector('[data-unfazed-status]');
    const success = section.querySelector('[data-unfazed-success]');
    const modal = section.querySelector('[data-rules-modal]');
    const dialog = modal.querySelector('[role="dialog"]');
    let modalTrigger = null;

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('unfazed-modal-open');
      document.removeEventListener('keydown', handleModalKeydown);
      modalTrigger && modalTrigger.focus();
    };

    const handleModalKeydown = (event) => {
      if (event.key === 'Escape') return closeModal();
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll(selectors)].filter((item) => !item.disabled);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    section.querySelectorAll('[data-rules-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        modalTrigger = trigger;
        modal.hidden = false;
        document.body.classList.add('unfazed-modal-open');
        document.addEventListener('keydown', handleModalKeydown);
        dialog.focus();
      });
    });
    modal.querySelectorAll('[data-rules-close]').forEach((button) => button.addEventListener('click', closeModal));

    const normalizePhone = (dial, value) => {
      let digits = String(value).replace(/\D/g, '');
      if (dial === '1') {
        digits = digits.replace(/^1(?=\d{10}$)/, '');
        return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? `+1${digits}` : null;
      }
      if (digits.indexOf(dial) === 0) digits = digits.slice(dial.length);
      return digits.length >= 6 && digits.length <= 14 ? `+${dial}${digits}` : null;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      status.textContent = '';
      const values = new FormData(form);
      const dial = (form.elements.country_code && form.elements.country_code.value) || '1';
      const phone = normalizePhone(dial, values.get('phone_number'));

      if (!form.reportValidity()) return;
      if (!phone) {
        status.textContent = 'Enter a valid phone number for the selected country.';
        form.elements.phone_number.focus();
        return;
      }

      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      button.textContent = 'Entering…';
      const emailOptIn = values.get('email_opt_in') === 'on';
      const subscriptions = { sms: { marketing: { consent: 'SUBSCRIBED' } } };
      if (emailOptIn) subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: values.get('email').trim(),
                  phone_number: phone,
                  first_name: values.get('first_name').trim(),
                  last_name: values.get('last_name').trim(),
                  location: { zip: values.get('zip').trim() },
                  subscriptions
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: section.dataset.listId } }
          }
        }
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(section.dataset.companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`Subscription failed (${response.status})`);
        form.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (error) {
        status.textContent = 'We could not submit your entry. Please check your details and try again.';
        button.disabled = false;
        button.textContent = 'Enter the giveaway';
      }
    });
  });
})();
